;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'
import type { ComponentProps } from 'react'

/**
 * Long-form body copy: links, lists, strong text and the spacing between them.
 *
 * The rhythm is proportional rather than even. `space-y-4` is the gap between two blocks that
 * merely follow each other; a heading opens more space above itself than below, and a list closes
 * up against the line that introduces it, so a section reads as one group instead of a stream of
 * evenly spaced fragments. The negative margins are how a smaller gap survives `space-y-4`: it
 * sets `margin-bottom` on the preceding block, and adjacent margins collapse to their sum.
 *
 * It deliberately does not size its headings. `clsx/lite` concatenates rather than merges, so a
 * caller that sets its own `[&_h2]` font size would land a second utility of equal specificity on
 * the same element and the winner would be decided by the order Tailwind happens to emit them —
 * which is how article headings ended up smaller than the `h3`s beneath them. Each consumer sets
 * the scale its own context needs.
 */
export function Document({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={clsx(
        'space-y-4 text-sm/7 text-mist-700 dark:text-mist-400 [&_a:not([data-control])]:font-semibold [&_a:not([data-control])]:text-mist-950 [&_a:not([data-control])]:underline [&_a:not([data-control])]:underline-offset-4 dark:[&_a:not([data-control])]:text-white [&_h2]:font-medium [&_h2]:text-mist-950 [&_h2]:not-first:mt-10 dark:[&_h2]:text-white [&_h3]:font-semibold [&_h3]:text-mist-950 dark:[&_h3]:text-white [&_li]:pl-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_strong]:font-semibold [&_strong]:text-mist-950 dark:[&_strong]:text-white [&_ul]:list-[square] [&_ul]:pl-6 [&_ul]:marker:text-mist-400 dark:[&_ul]:marker:text-mist-600',
        // Written as sibling pairs rather than as `not-first` so the browser, not Tailwind's
        // emit order, decides the ties: `h2+h3` outranks `*+h3`, and a subheading that opens a
        // section it shares with its `h2` sits closer to it than one that starts a new one.
        '[&_*+h3]:mt-8 [&_h2+*]:-mt-1 [&_h2+h3]:mt-4 [&_h3+*]:-mt-2 [&_p+ol]:-mt-2 [&_p+ul]:-mt-2',
        className,
      )}
      {...props}
    data-sentry-component="Document" data-sentry-source-file="document.tsx">
      {children}
    </div>
  )
}
